export default function parseJWT(
  token: undefined | string
): Record<string, unknown> | null {
  // Note: some M365 mobile client apps return non-JWT values
  // (undefined, empty string, "[object Object]", etc.)
  if (typeof token !== 'string') return null;

  const parts = token.split('.');
  if (parts.length < 2 || !parts[1]) return null;

  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload) as Record<string, unknown>;
}
